import { z } from 'zod'
import { ContactRequestSchema } from './contact.js'
import { isoDate, listQuerySchema, searchText } from './lists.js'

/** Canali da cui arriva una richiesta del CRM; etichette in `admin.requests.channels.<canale>`. */
export const REQUEST_CHANNELS = ['contact_form'] as const

export type RequestChannel = (typeof REQUEST_CHANNELS)[number]

/** POST /api/requests e PUT /api/requests/:id: mittente, canale e messaggio (stesse regole del form contatti). */
export const RequestInputSchema = z.object({
  senderName: ContactRequestSchema.shape.name,
  senderEmail: ContactRequestSchema.shape.email,
  channel: z.enum(REQUEST_CHANNELS),
  message: ContactRequestSchema.shape.message,
})

export type RequestInput = z.infer<typeof RequestInputSchema>

/** Richiesta come la vede l'area gestionale (GET /api/requests, /api/requests/:id). */
export type AdminRequest = RequestInput & { id: string; createdAt: string }

/** GET /api/requests: `channel` è il filtro rapido, gli altri campi la ricerca avanzata; di default le più recenti. */
export const RequestListQuerySchema = listQuerySchema(
  ['createdAt', 'senderName', 'senderEmail'],
  {
    channel: z.enum(REQUEST_CHANNELS).optional(),
    senderName: searchText,
    senderEmail: searchText,
    message: searchText,
    createdFrom: isoDate,
    createdTo: isoDate,
  },
  'desc',
)

export type RequestListQuery = z.infer<typeof RequestListQuerySchema>
